import styled from 'styled-components';

export const StyledErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.error};
  margin: 0 0 8px;
`;
